/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEscalationTicketRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetEscalationTicketResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getEscalationTicket = (request: GetEscalationTicketRequest, options?: CashRequestOptions) => post<GetEscalationTicketRequest, GetEscalationTicketResponse>("/2.0/cash/get-escalation-ticket", request, {...options, rejectOnError: true })